import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { InputGeneral } from '../../inputs/input-general/input-general';
import { MatButtonModule } from '@angular/material/button';
import { LocationSite } from '../../models/location-model/location.model';
import { GoogleMapsModule } from '@angular/google-maps';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'app-map-general',
  imports: [MatIcon, MatButtonModule, GoogleMapsModule],
  templateUrl: './map-general.html',
  styleUrl: './map-general.css',
})
export class MapGeneral {
  public center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  public zoom = 9;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MapGeneral>,
    @Inject(MAT_DIALOG_DATA) public data: { location: LocationSite },
    private locationService: LocationService,
  ) {}

  ngOnInit(): void {
    this.locationService.getLocationDetail(this.data.location.Id).subscribe((response) => {
      if (response && response.Data) {
        this.center = {
          lat: Number(response.Data.Latitude) || 24,
          lng: Number(response.Data.Longitude) || 12,
        };
      }
    });
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }
}
